const KEY_PREFIX = "tp.getTheAppCard.dismissed.";

/** Whether this person hid the Home card. Storage that throws (private mode) reads as not hidden. */
export function isGetTheAppCardDismissed(userId: string): boolean {
  try {
    return window.localStorage.getItem(`${KEY_PREFIX}${userId}`) === "1";
  } catch {
    return false;
  }
}

/** Remembers the dismissal for good; when storage throws, the card stays hidden for this visit only. */
export function dismissGetTheAppCard(userId: string): void {
  try {
    window.localStorage.setItem(`${KEY_PREFIX}${userId}`, "1");
  } catch {
    // Storage unavailable: the in-memory state still hides the card until the next visit.
  }
}
